import { Injectable, inject } from '@angular/core';
import { Octopus } from '@maximizer/core/shared/domain';
import { Observable, catchError, map, of, timeout } from 'rxjs';
import { EmailSendResult, OutgoingEmailMessage } from '../models/email-draft';
import {
  EmailMessage,
  EmailMessageRequest,
  EmailService,
} from './email.service';

const HTML_TYPE = 1;
const SEND_TIMEOUT_MS = 60_000;

@Injectable()
export class EmailMessageService {
  private readonly emailService = inject(EmailService);

  send(message: OutgoingEmailMessage): Observable<EmailSendResult> {
    const data: EmailMessage = {
      Key: null,
      From: message.from,
      To: message.to,
      Subject: message.subject,
      Type: HTML_TYPE,
      Body: message.bodyHtml,
    };
    if (message.cc.length > 0) {
      data.Cc = message.cc;
    }
    if (message.bcc.length > 0) {
      data.Bcc = message.bcc;
    }
    const request: EmailMessageRequest = { EmailMessage: { Data: data } };
    return this.emailService.create(request).pipe(
      map((response): EmailSendResult =>
        response.Code === Octopus.ResponseStatusCode.Successful
          ? 'sent'
          : 'failed',
      ),
      timeout({
        first: SEND_TIMEOUT_MS,
        with: () => of<EmailSendResult>('unknown'),
      }),
      catchError(() => of<EmailSendResult>('failed')),
    );
  }
}
